import { useAuth } from '@teko/auth-react';
import { Policy } from '@teko/ecommerce/mobile';
import { useFeatureFlags } from 'contexts';
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
import { useTenantConfig } from '../hooks';
import { publicService } from '../services';
import { ProductPolicy } from '../types';

const OTHER_POLICIES = 0;

const convertPolicies = (policies: ProductPolicy[]): Policy[] => {
  return policies.map((el, index) => ({
    id: index,
    content: el.displayText,
    icon: el.iconUrl,
    detailUrl: el.detailUrl,
  }));
};

export const usePolicies = (
  sku: string,
  sellerId?: number,
  isHighlightedOnPromotionBlock?: boolean,
) => {
  const [policies, setPolicies] = useState<ProductPolicy[]>([]);
  const { terminalId, currentLanguage, terminal, useTerminalId } =
    useTenantConfig();
  const { flags } = useFeatureFlags();
  const { loading } = useAuth();

  useEffect(() => {
    const fetchPolicies = () => {
      publicService
        .getSalePoliciesBySku(
          {
            sku,
            ...(flags.epic_omni_1237 ? { sellerId } : {}),
            ...(flags.epic_ecom_284 || useTerminalId
              ? { terminalId }
              : { terminalCode: terminal }),
            isHighlightedOnPromotionBlock,
          },
          currentLanguage,
        )
        .then(({ policies: value }) =>
          setPolicies(
            value.map((policy) => ({
              ...policy,
              // after remove 305 --> displayText is required param
              displayText: DOMPurify.sanitize(policy.displayText || ''),
            })),
          ),
        );
    };
    if (!!sku && !loading) {
      fetchPolicies();
    }
  }, [sku, sellerId, loading]);

  const salePolicies = policies.filter(
    (policies) => policies.serviceGroupId !== OTHER_POLICIES,
  );
  const otherPolicies = policies.filter(
    (policies) => policies.serviceGroupId === OTHER_POLICIES,
  );
  return {
    policies: convertPolicies(policies),
    salePolicies: convertPolicies(salePolicies),
    otherPolicies: convertPolicies(otherPolicies),
  };
};
